import { render, staticRenderFns } from "./SingleSignOnSettings.vue?vue&type=template&id=7d4fdbc4&scoped=true"
import script from "./SingleSignOnSettings.vue?vue&type=script&lang=ts"
export * from "./SingleSignOnSettings.vue?vue&type=script&lang=ts"
import style0 from "./SingleSignOnSettings.vue?vue&type=style&index=0&id=7d4fdbc4&prod&scoped=true&lang=scss"
import style1 from "./SingleSignOnSettings.vue?vue&type=style&index=1&id=7d4fdbc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4fdbc4",
  null
  
)

export default component.exports